import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const GPCard = ({
  gp,
  marker,
  onChoose,
  idx,
  gpCardRefs,
}) => {
  return (
    <div
      key={idx}
      ref={gpCardRefs?.current[idx]}
      className="p-5 border rounded-xl shadow-sm bg-white space-y-4 transition-all duration-300"
    >
      <div className="flex flex-col sm:flex-row justify-between items-start">
        <div>
          <h3 className="text-lg font-bold">{marker?.name}</h3>
          <p className="text-gray-600 flex items-center gap-2">
            <FontAwesomeIcon icon={faMapMarkerAlt} className="text-gray-500" />
            {gp?.address || 'Address not available'}
          </p>
        </div>

        <div className="flex flex-col gap-2 items-end mt-4 w-full sm:w-auto sm:mt-0">
          <button
            onClick={() => onChoose(marker?.gp)}
            className="w-full sm:w-56 h-12 px-6 py-3 bg-[#7B5FA6] rounded-md text-sm font-bold hover:bg-[#DDCCDF] text-white flex justify-center items-center"
          >
            Choose GP
          </button>
        </div>
      </div>
    </div>
  )
}

export default GPCard
